/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID || "";
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";